// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1XxS7","title":"FrontImage_title__arSNU"};